module.exports = __webpack_public_path__ + "img/map.a642a08b.jpg";